import { createSelector } from 'reselect';


export const isSavingScenarioSelector = ({ scenarios }) =>
  scenarios.list.isLoadingScenarioCreate
|| scenarios.list.isLoadingScenarioUpdate;

export const isRemovingScenarioSelector = ({ scenarios }) =>
  scenarios.list.isLoadingScenarioRemove;

export const scenarioListColumnStateSelector = ({ scenarios }) =>
  scenarios.list.columnState;

export const periodsOptionsSelector = createSelector(
  ({ shared }) => shared.periods,
  periods => periods.map(({ name }) => ({
    label: name,
    value: name,
  }))
);


export const canCreatePublicScenarioSelector = ({ user }) => user.user.permissions.commands.canCreatePublicScenario;

export const canRemoveScenarioSelector = ({ user }) => user.user.permissions.commands.canRemoveScenario;
